namespace Portico.Models.Enterprise {
    export interface ISurveySessionAnswer {
        questionId: number;
        answerId: number;
        answerValue: string;
        surveySessionId: number;
    }

    export class SurveySessionAnswer implements ISurveySessionAnswer {
        questionId: number;
        answerId: number;
        answerValue: string;
        surveySessionId: number;

        constructor(obj?: ISurveySessionAnswer) {
            this.questionId = null;
            this.answerId = null;
            this.answerValue = null;
            this.surveySessionId = null;

            if (obj) {
				this.questionId = obj.questionId || null;
				this.answerId = obj.answerId || null;
				this.answerValue = obj.answerValue || null;
                this.surveySessionId = obj.surveySessionId || null;
            }
        }
    }
}

